<template>
  <!---性别--->
  <el-select v-model="sexCode" clearable>
    <el-option
      v-for="item in sexList"
      :key="item.dictCode"
      :label="item.dictName"
      :value="item.dictCode">
    </el-option>
  </el-select>
  <!---------->
</template>

<script>
  import {getListByTypeCodeAndPCode} from '@/api/dict/dic_manage'

  export default {
    name: "select-sex",
    data() {
      return {
        sexList: [],
        sexCode: ''
      }
    },
    created() {
      let data = {
        dictTypeCode: 'SEX',
        parentCode: -1,
      }
      getListByTypeCodeAndPCode(data).then(res => {
        if (res.code == 1) {
          this.sexList = res.data
        }
      })
    },
    watch: {
      sexCode: function (currentVal) {
        this.$emit('sexInfo', {sexCode: currentVal})
      }
    }
  }
</script>

<style scoped>

</style>
